//Core
import {createAsyncThunk} from "@reduxjs/toolkit";
import {User} from "@auth0/auth0-react";
//Redux
import {store} from "@/redux/store";
//Services
import {createUserAPI, getUserAPI} from "@/services/userService";
//Types
import {TUserData} from "@/types/redux/userTypes";
import {TGetUserActionPayload, TUserDataResponse} from "@/types/services/user/response/userDataResponseTypes";
//Utils
import {fetchListItems} from "@/utils/fetchListItems";
import {DEV_ONLY, STAGING} from "@/constants";

const userExist = (data: TUserDataResponse) : TGetUserActionPayload => {
    const userData: TUserData = {
        name: data?.name ?? "",
        email: data?.email ?? "",
        wallet: data?.wallet || null,
        image: data?.image ?? "",
    };
    return {
        userData: userData,
        pixelStatus: data?.pixel_status ?? "notConnected",
    };
}

export const fetchGetUser = createAsyncThunk(
    "user/fetchGetUser",
    async (user: User, {rejectWithValue}) => {
        const user_id = user?.sub !== '' ? user.sub : store.getState().user.userId;
        try {
            const response = await getUserAPI(user_id);
            console.log(response, 'response')
            let dataUser = response?.data;
            console.log(DEV_ONLY, 'DEV_ONLY')
            console.log(STAGING, 'STAGING')
            if (dataUser) return userExist(dataUser);
            else if (
                response?.errors === 1 &&
                response?.message === "User not found" &&
                (DEV_ONLY || STAGING) &&
                user?.sub &&
                user.sub !== ''
            ) {
                const userData = await createUserAPI(user);
                if (userData) return userExist(userData);
            } else return null;
        } catch (error) {
            return rejectWithValue(null);
        }
    },
    {
        condition: (_data, {getState}) => {
            const {
                app: {fetchList},
            }: any = getState();
            if (fetchList.includes(fetchListItems.getUser)) return false;
        },
    }
);